export { default } from './ProductTiles';
